"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableRow = exports.TableHeader = exports.TableFooter = exports.TableCell = exports.TableBody = exports.Table = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Table = require("grommet/es6/components/Table");

var _TableBody = require("grommet/es6/components/TableBody");

var _TableCell = require("grommet/es6/components/TableCell");

var _TableFooter = require("grommet/es6/components/TableFooter");

var _TableHeader = require("grommet/es6/components/TableHeader");

var _TableRow = require("grommet/es6/components/TableRow");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ExtendedTable = (0, _styledComponents["default"])(_Table.Table).withConfig({
  displayName: "Table__ExtendedTable",
  componentId: "kx4pwg-0"
})([""]);

var Table = function Table(props) {
  return /*#__PURE__*/_react["default"].createElement(ExtendedTable, props);
};

exports.Table = Table;
var ExtendedTableBody = (0, _styledComponents["default"])(_TableBody.TableBody).withConfig({
  displayName: "Table__ExtendedTableBody",
  componentId: "kx4pwg-1"
})([""]);

var TableBody = function TableBody(props) {
  return /*#__PURE__*/_react["default"].createElement(ExtendedTableBody, props);
};

exports.TableBody = TableBody;
var ExtendedTableCell = (0, _styledComponents["default"])(_TableCell.TableCell).withConfig({
  displayName: "Table__ExtendedTableCell",
  componentId: "kx4pwg-2"
})([""]);

var TableCell = function TableCell(props) {
  return /*#__PURE__*/_react["default"].createElement(ExtendedTableCell, props);
};

exports.TableCell = TableCell;
var ExtendedTableFooter = (0, _styledComponents["default"])(_TableFooter.TableFooter).withConfig({
  displayName: "Table__ExtendedTableFooter",
  componentId: "kx4pwg-3"
})([""]);

var TableFooter = function TableFooter(props) {
  return /*#__PURE__*/_react["default"].createElement(ExtendedTableFooter, props);
};

exports.TableFooter = TableFooter;
var ExtendedTableHeader = (0, _styledComponents["default"])(_TableHeader.TableHeader).withConfig({
  displayName: "Table__ExtendedTableHeader",
  componentId: "kx4pwg-4"
})([""]);

var TableHeader = function TableHeader(props) {
  return /*#__PURE__*/_react["default"].createElement(ExtendedTableHeader, props);
};

exports.TableHeader = TableHeader;
var ExtendedTableRow = (0, _styledComponents["default"])(_TableRow.TableRow).withConfig({
  displayName: "Table__ExtendedTableRow",
  componentId: "kx4pwg-5"
})([""]);

var TableRow = function TableRow(props) {
  return /*#__PURE__*/_react["default"].createElement(ExtendedTableRow, props);
};

exports.TableRow = TableRow;